const isWhite = (color: string): boolean => {
  const normalized = color.trim().toLowerCase()
  return (
    normalized === '#ffffff' ||
    normalized === '#fff' ||
    normalized === 'rgb(255, 255, 255)' ||
    normalized === 'rgb(255,255,255)'
  )
}

const toWuRgb = (color: string): string | null => {
  if (!color) return null

  const rgb = color.match(/rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/)
  if (rgb) return `${rgb[1]} ${rgb[2]} ${rgb[3]}`

  const hex = color.match(/^#([0-9a-fA-F]{6})$/)
  if (hex) {
    const r = parseInt(hex[1].slice(0, 2), 16)
    const g = parseInt(hex[1].slice(2, 4), 16)
    const b = parseInt(hex[1].slice(4, 6), 16)
    return `${r} ${g} ${b}`
  }

  return null
}

export interface IPanelTheme {
  theme_color?: string
  header_bg_color?: string
  menu_header_color?: string
  primary_button?: string
  element_color?: string
  icon_color?: string
  font_color?: string
}

export const parsePanelTheme = (panelThemeJson: string): IPanelTheme | null => {
  try {
    return JSON.parse(panelThemeJson)
  } catch {
    return null
  }
}

export const applyPanelTheme = (theme: IPanelTheme): void => {
  const root = document.documentElement

  if (theme.header_bg_color && !isWhite(theme.header_bg_color)) {
    root.style.setProperty('--theme-header-bg', theme.header_bg_color)
    const headerWu = toWuRgb(theme.header_bg_color)
    if (headerWu) root.style.setProperty('--base-header-portal', headerWu)
  } else {
    root.style.removeProperty('--theme-header-bg')
    root.style.removeProperty('--base-header-portal')
  }

  if (theme.theme_color && !isWhite(theme.theme_color)) {
    root.style.setProperty('--theme-color', theme.theme_color)
    const themeWu = toWuRgb(theme.theme_color)
    if (themeWu) root.style.setProperty('--portal-sidebar', themeWu)
  } else {
    root.style.removeProperty('--theme-color')
    root.style.removeProperty('--portal-sidebar')
  }
}
